import React from 'react';
import { Image, Sidebar } from 'semantic-ui-react';
import { useResponsive } from 'ahooks';

import { useAppDispatch, useAppSelector } from 'src/store';
import drawer, { DrawerName } from 'src/store/ui/drawer';

import { ClassSider } from 'src/components/coreUI/index';
import logo from 'src/assets/logo.png';

export const drawer_name: DrawerName = 'class_sider';

const ClassSiderDrawer: React.FC = () => {
  const { visible, name } = useAppSelector((state) => state.ui.drawer);
  const dispatch = useAppDispatch();
  const screen = useResponsive();

  return !screen.lg ? (
    <Sidebar
      animation="overlay"
      icon="labeled"
      onHide={() => dispatch(drawer.close({ name: drawer_name }))}
      visible={visible && name === drawer_name}
      width={!screen.sm ? 'wide' : 'very wide'}
      direction="left"
      className="bg-white"
    >
      <div className="pl-24 py-8">
        <Image width={140} height={45} src={logo} alt="logo" />
      </div>
      <ClassSider />
    </Sidebar>
  ) : null;
};

export default ClassSiderDrawer;
